import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

import { colors } from "@/theme/tokens/colors";

export const CircleHalfOutlinedIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    {/* Right half */}
    <path
      d="M9.75 18.75C14.7206 18.75 18.75 14.7206 18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75"
      stroke="#ADADAD"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
      fill="none"
    />

    {/* Left half */}
    <path
      d="M9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75"
      stroke={colors.brand.blue}
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
